<template>
  <div class="flex-space align-center" v-if="isImport(item)">
    <container-eta
      :id="item.id"
      :etaData="{ terminal_eta: item.terminal_eta, eta_time: item.eta_time }"
    />
    <popup
      componentPath="components/html"
      width="1200"
      :options="{
        title: 'ETA Details',
        url: '/import_containers/' + item.id + '/eta',
        width: '100%',
      }"
    >
      <i class="el-icon-info"></i>
    </popup>
  </div>
</template>

<script>
export default {
  name: "order-status-eta",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
